import { FC } from "react";
import { Route } from "react-router-dom";
import { ShowAngularApp } from "./ShowAngularApp";
import { LegacyAwareRouter } from "./LegacyAwareRouter";
/**
 * Base mobile react routes. When we no longer need the dynamic routing
 * features that pull in angularjs routes, this can be converted to a
 * single static router.
 *
 * Register all react routes here in a `<Route>` component hierarchy. All routes
 * will be nested under a global route that renders the `<WebClientApp>`
 */
const mobileRoutes = [
  <Route path="*" element={<ShowAngularApp />} key="root" />,
];

export const MobileRouter: FC = () => (
  <LegacyAwareRouter reactRoutes={mobileRoutes} />
);
